import { Tag } from '../../model/tagging/Tag';
import { Factory } from '../../services/Factory';
import { Batch } from '../../model/batching/Batch';
import { BatchService } from '../../services/batching/BatchService';
import { INotificationService } from '../../services/notification';
import { IRootScope } from '../../IRootScope';

interface IAssignBatchScope extends angular.IScope {
  batch: Tag;
  batchClone: Tag;
  close: Function;
  assign: Function;
}

export class AssignBatchModalController {
  constructor($scope: IAssignBatchScope, $rootScope: IRootScope, $modalInstance: any, project: any, batch: Tag, batchService: BatchService, notificationService: INotificationService) {
      $scope.batchClone = {...batch};

      $scope.close = () => {
        $modalInstance.dismiss('cancel');
      };

      $scope.assign = async () => {
        await batchService.Assign(project, new Batch(batch.id, $scope.batchClone.users || [], $scope.batchClone.roles || []));
        $modalInstance.close();
      };
    }
  }

frontendApp.controller("AssignBatchModalController", ["$scope", "$rootScope", "$uibModalInstance", "project", "batch", "BatchService", "NotificationService", Factory.Create(AssignBatchModalController)]);
